module.exports = __webpack_public_path__ + "img/field_2.b875f5e3.jpg";